import React from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { Entity } from "@common/types/entity";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { EntityDisplay } from "@components/entity/EntityDisplay";

const LockEntityCellComponent: React.FC<
    CellContext<ViewTableFeatures, Entity, string | null>
> = ({ row }) => (
    <ViewTableCell>
        <EntityDisplay entity={row.original} />
    </ViewTableCell>
);

export const LockEntityCell = React.memo(LockEntityCellComponent);
LockEntityCell.displayName = "LockEntityCell";
